import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { checkNested } from 'srcReact/helpers/validator'
import { organizationSettingsActions } from 'srcReact/OrganizationSettingsPage'
import Icon from 'srcReact/components/icons/Icon'
import Button from 'srcReact/components/common2/Button'
import { redirectToPage } from 'srcReact/helpers/history'
import DesktopHeader from '../DesktopHeader'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { formatUnixTimestampToDate } from 'srcReact/helpers/datetimeHelper'
import { getConvertCentToDollar } from 'srcReact/helpers/utils'

const YourPlan = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isMobile },
    organization: { current_organization },
    organizationSettings: { plan }
  } = useSelector((state) => state)

  useEffect(() => {
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(organizationSettingsActions.getOrganizationSubscription(current_organization.info.id, 1))
    }
  }, [current_organization && current_organization.info && current_organization.info.id])

  return (
    <div className={styles.yourPlanWrapper}>
      {!isMobile && (
        <DesktopHeader
          title={t('organizationSettings.yourPlan.title')}
          subtitle={t('organizationSettings.yourPlan.subtitle')}
        />
      )}
      {/* <Button
        size='large'
        style='orange'
        handleClick={() => redirectToPage('/contact-us')}
        text={t('organizationSettings.yourPlan.upgradePlan')}
        customStyle={styles.buttonCustomStyle}
      /> */}
      <ul className={styles.planInfo}>
        <li>
          <span>{t('organizationSettings.yourPlan.info.plan')}: </span>{' '}
          {plan.name && t(`organizationSettings.yourPlan.info.${plan.name.toLowerCase().replace(/\s/g, '')}`)}
        </li>
        <li>
          <span>{t('organizationSettings.yourPlan.info.availableLicenses')}: </span> {plan.available_licenses_count}
        </li>
        <li>
          <span>{t('organizationSettings.yourPlan.info.nextBillingDate')}: </span>{' '}
          {plan.current_term_end && formatUnixTimestampToDate(plan.current_term_end, appConstantSettings.DATE_FORMAT8)}
        </li>
        {/* <li>
          <span>{t('organizationSettings.yourPlan.info.billingPeriodicity')}: </span>{' '}
          {plan.billing_period_unit_display &&
            t(
              `organizationSettings.yourPlan.info.${plan.billing_period_unit_display.toLowerCase().replace(/\s/g, '')}`
            )}
        </li> */}
        {/* <li>
          <span>{t('organizationSettings.yourPlan.info.pricing')}: </span>{' '}
          {`${getConvertCentToDollar(plan.plan_unit_price, plan.currency_code)} / ${t(
            'organizationSettings.yourPlan.info.member'
          )} / ${plan.billing_period_unit && t(`organizationSettings.yourPlan.info.${plan.billing_period_unit}`)}`}
        </li> */}
        <li>
          <span>{t('global.members')}: </span> {plan.organization_member_quantity}
        </li>
        <li>
          <span>{t('organizationSettings.yourPlan.info.groups')}: </span>{' '}
          {t('organizationSettings.yourPlan.info.unlimited')}
        </li>
        <li>
          <span>{t('organizationSettings.yourPlan.info.mixrs')}: </span>{' '}
          {t('organizationSettings.yourPlan.info.unlimited')}
        </li>
        <li>
          <span>{t('organizationSettings.yourPlan.info.privateMessages')}: </span>{' '}
          {t('organizationSettings.yourPlan.info.unlimited')}
        </li>
        <li>
          <span>{t('organizationSettings.yourPlan.info.workplaces')}: </span>{' '}
          {`${plan.organization_workplace_quantity} / ${plan.workplace_limit}`}
        </li>
        {/* <button className={styles.changeYourPlan} onClick={() => redirectToPage('/0/support')}>
          {t('organizationSettings.yourPlan.info.changeYourPlan')} <Icon name='arrow-right' size='medium' />
        </button> */}
      </ul>
    </div>
  )
}

export default YourPlan
